
            import "data:text/css,.m-checkingVerificationIcon-e0808d711b%7Bwidth:24px;height:24px%7D";
            const result = {"checkingVerificationIcon":"m-checkingVerificationIcon-e0808d711b"};
            export default result;
          